import React from 'react'

import './Label.css'

interface LabelProps {
  htmlFor: string
  /** Extra class name, e.g. `visuallyHidden` when the design shows a placeholder instead. */
  className?: string
  children: React.ReactNode
}

function Label(props: LabelProps) {
  return (
    <label htmlFor={props.htmlFor} className={props.className}>
      {props.children}
    </label>
  )
}

export default Label
